import { DayOfWeek } from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryGeoCoordinates,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

export interface IPracticeDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  name: string;
  slug: string;
  address: string;
  phone: string;
  email: string;
  coordinates?: IBigQueryGeoCoordinates;
  settings: {
    /**
     * Timezone is an invalid avro enum
     */
    timezone: string;
  };
  tyroSettings?: {
    iClient: string;
  };
  schedule: IBigQueryRoster;
  yearOpened: number;
}

interface IScheduleRange {
  from: string;
  to: string;
}

interface IRosterShiftTimes {
  shift: IScheduleRange;
  break?: IScheduleRange & { isBlocking?: boolean };
}

interface IRosterTime extends IRosterShiftTimes {
  dayOfWeek: DayOfWeek;
}

export interface IBigQueryRoster {
  default?: IRosterShiftTimes;
  days: IRosterTime[];
}
